import designEyeQ from 'assets/images/shingles/Design-EyeQ.png';
import ContentAndImage from '../../../components/OC/oc-content-and-image'
import { connectLocation } from '../../location/LocationConnectors';
import { PrefixWithLocale } from '../../Utilities';
import LocaleSpecific from '../../LocaleSpecific';
import Text from '../../OC/oc-text.jsx';
import Picture from '../../OC/oc-picture';

const HelpWithColor = connectLocation(({ t }) => (
  <section className="pys__help-with-color" id="help-with-color">
    <h2>{t('shingles.statics.helpWithColor.title')}</h2>

    <LocaleSpecific only={['en-US','es-US']}>
      <VisualizeYourRoof />
    </LocaleSpecific>

    <LocaleSpecific only={['en-US','es-US']}>
      <StyleBoardInspiration />
    </LocaleSpecific>

    <GetExpertHelp />
  </section>
));

const WomensChoiceAward = connectLocation(({ t }) => (
  <div className="gallery pys__womens-choice-award gallery-section">
    <div className="womens-choice-award__left">
      <h2 className="h3">{t('shingles.statics.wca.title')}</h2>
      <h3 className="h2">{t('shingles.statics.wca.love')}</h3>
      <div>
        <Text content={t('shingles.statics.wca.description')} />
      </div>
    </div>
    <div className="womens-choice-award__right">
      <Picture 
        source={"https://imagecdn.owenscorning.com/image/upload/f_auto,q_auto/v1707837376/roofing/wca/2024/wca-2024-image.jpg"} 
        alt={""} 
      />
    </div>
  </div>
));

const PYSNotes = connectLocation(({t, shingle = {}}) => {
  const {uid, shingle_standards = []} = shingle;
  const hasCSANote = uid.includes('flex') && shingle_standards.find(s => s.uid === 'csa-a123_5' || s.uid === 'csa-a123-5');
  const hasImpactNote = shingle.impact_resistance_uid === 'class-3' || shingle.impact_resistance_uid === 'class-4';
  return (
    <section className="pys__notes">
      <p><Text content={t('shingles.statics.pysNotes.photographs')} /></p>
      {hasImpactNote ? <p><Text content={t('shingles.statics.pysNotes.impactResistanceNote')} /></p> : null}
      <p><Text content={t('shingles.statics.pysNotes.surenail')} /></p>
      {hasCSANote ? <p><Text content={t('shingles.statics.pysNotes.csa-a123_5')} /></p> : null}
      <p><Text content={t('shingles.statics.pysNotes.tlp')} /></p>
      <p><Text content={t('shingles.statics.pysNotes.patent')} /></p>
      <p><Text content={t('shingles.statics.pysNotes.warranty')} /></p>
      <p><Text content={t('shingles.statics.pysNotes.exclusions')} /></p>
      <p><Text content={t('shingles.statics.pysNotes.effective_coverage')} /></p>
    </section>
  )
});

const VisualizeYourRoof = connectLocation(({ t }) => (
  <div className="help-with-color__visualize">
    <div className="visualize__image" style={{ backgroundImage: `url(${designEyeQ})` }}></div>
    <h3 className="body-font">{t('shingles.statics.visualize.title')}</h3>
    <p>{t('shingles.statics.visualize.description')}</p>
    <a
      href="http://designeyeq.owenscorning.com/?src=rfg"
      className="oc-cta-button"
      data-track="learn-more"
      data-track-element-location="main section CTA"
      data-track-destination="Visualize Your Home"
    >
      {t('shingles.statics.visualize.cta')}
    </a>
  </div>
));

const StyleBoardInspiration = connectLocation(({ t, locale }) => (
  <div className="help-with-color__visualize">
    <div className="inspiration__image" style={{ backgroundImage: `url(https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto,q_auto/c_fill,q_50/c_scale,q_50,w_1340/v1634164312/roofing/design-and-inspire/style-boards/Merlot-Fireworks-Desktop.jpg)` }}></div>
    <h3 className="body-font">{t('shingles.statics.inspiration.title')}</h3>
    <p>{t('shingles.statics.inspiration.description')}</p>
    <a
      href={PrefixWithLocale("/roofing/design-inspire/colors-of-the-season?tab=style-boards", locale.code)}
      className="oc-cta-button"
      data-track="learn-more"
      data-track-element-location="main section CTA"
      data-track-destination="View All Style Boards"
    >
      {t('shingles.statics.inspiration.cta')}
    </a>
  </div>
));

const GetExpertHelp = connectLocation(({ t }) => (
  <ContentAndImage ratio="1-1" video="vWXGjwF8u8U" noMargin='true'>
    <div>
      <h3 className="body-font">{t('shingles.statics.get_expert_help.title')}</h3>
      <p>{t('shingles.statics.get_expert_help.description')}</p>
    </div>
  </ContentAndImage>
));

export { HelpWithColor, WomensChoiceAward, PYSNotes };
